(function () {
  var THRESHOLD = 40; // px
  var root = document.documentElement;

  function isHome() {
    return (
      document.body.classList.contains('template-index') ||
      document.querySelector('main[data-template*="index"]')
    );
  }

  function update() {
    if (!isHome()) return;
    root.classList.toggle('restmt-header-solid', window.scrollY > THRESHOLD);
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
  update();
})();
